<div fxLayout="row" fxLayoutAlign="start center">
    <mat-icon>{{ data?.icon }}</mat-icon> <span style="margin-left: 16px;">{{ data?.message }}</span>
</div>